<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Создать новый предмет</h4>
            </div>
            <div class="card-body">

              <div v-if="successMessage" class="alert alert-success">
                <span>{{ successMessage }}</span>
                <button type="button" class="close" @click="successMessage = null">×</button>
              </div>

              <div v-if="errorMessage" class="alert alert-danger">
                <span>{{ errorMessage }}</span>
                <button type="button" class="close" @click="errorMessage = null">×</button>
              </div>

              <form @submit.prevent="createSubject">
                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>Название предмета</label>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Например: Математика"
                        v-model="subjectName"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-4 d-flex align-items-end">
                    <button type="submit" class="btn btn-info btn-fill btn-block mb-3" :disabled="loading">
                      {{ loading ? 'Загрузка...' : 'Создать' }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="card">

            <div class="card-header d-flex justify-content-between align-items-center">
              <div>
                <h4 class="card-title">Список предметов</h4>
                <p class="category">Все доступные предметы</p>
              </div>

              <div class="pagination-controls" v-if="subjects.length > 0 || pageIndex > 1">
                 <button
                   class="btn btn-sm btn-secondary btn-fill"
                   :disabled="pageIndex === 1 || fetching"
                   @click="changePage(-1)"
                 >
                   <i class="fa fa-chevron-left"></i> Назад
                 </button>

                 <span class="mx-3 font-weight-bold">Стр. {{ pageIndex }}</span>

                 <button
                   class="btn btn-sm btn-secondary btn-fill"
                   :disabled="isLastPage || fetching"
                   @click="changePage(1)"
                 >
                   Вперед <i class="fa fa-chevron-right"></i>
                 </button>
              </div>
            </div>

            <div class="card-body table-full-width table-responsive">
              <table class="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Название</th>
<!--                    <th>Тип (SubjectType)</th>-->
                    <th>Дата создания</th>
                    <th class="text-right">Действия</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="fetching">
                    <td colspan="5" class="text-center">Загрузка списка...</td>
                  </tr>
                  <tr v-if="subjects.length === 0 && !fetching">
                    <td colspan="5" class="text-center">Список пуст</td>
                  </tr>
                  <tr v-for="(subject, index) in subjects" :key="subject.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ subject.name }}</td>
<!--                    <td>{{ subject.subjectType !== null ? subject.subjectType : '-' }}</td>-->
                    <td>{{ formatDate(subject.createdAt) }}</td>
                    <td class="text-right">
                      <button
                        class="btn btn-danger btn-sm btn-fill"
                        @click="deleteSubject(subject.id)"
                        title="Удалить"
                      >
                        <i class="fa fa-trash"></i> Удалить
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-muted small p-3" v-if="subjects.length > 0">
                 Показано {{ subjects.length }} записей (Лимит: {{ pageSize }})
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// ✅ IMPORT API_URL HERE
import { API_URL } from '../server';

export default {
  name: 'CreateSubject',
  data() {
    return {
      // Create Form Data
      subjectName: '',
      loading: false,

      // List Data
      subjects: [],
      fetching: false,

      // Pagination Data
      pageIndex: 1,
      pageSize: 50,
      isLastPage: false,

      // Messages
      errorMessage: null,
      successMessage: null,
    };
  },
  mounted() {
    this.fetchSubjects();
  },
  methods: {
    // 1. GET ALL SUBJECTS (With Pagination)
    async fetchSubjects() {
      this.fetching = true;
      const token = localStorage.getItem('token');

      try {
        // ✅ USE API_URL + Endpoint + Params
        const response = await axios.get(
          API_URL + '/api/subject',
          {
            headers: {
              'accept': '*/*',
              'Authorization': `Bearer ${token}`
            },
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize
            }
          }
        );

        if (response.data && response.data.code === 200) {
          const data = response.data.data || [];
          this.subjects = data;
          // Determine if we are on the last page based on array size
          this.isLastPage = data.length < this.pageSize;
        } else {
          this.subjects = [];
        }
      } catch (error) {
        console.error('Error fetching subjects:', error);
      } finally {
        this.fetching = false;
      }
    },

    // 2. Change Page
    changePage(direction) {
      this.pageIndex += direction;
      this.fetchSubjects();
    },

    // 3. CREATE SUBJECT
    async createSubject() {
      this.loading = true;
      this.errorMessage = null;
      this.successMessage = null;

      const token = localStorage.getItem('token');

      if (!token) {
        this.errorMessage = 'Ошибка авторизации.';
        this.loading = false;
        return;
      }

      try {
        const payload = {
          name: this.subjectName,
          subjectType: 0
        };

        // ✅ USE API_URL + Endpoint
        const response = await axios.post(
          API_URL + '/api/subject',
          payload,
          {
            headers: {
              'accept': '*/*',
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }
        );

        if (response.data && response.data.code === 200) {
          this.successMessage = `Предмет "${this.subjectName}" успешно создан!`;
          this.subjectName = '';
          // Reset to page 1 to see the new item
          this.pageIndex = 1;
          this.fetchSubjects();
        } else {
          this.errorMessage = 'Не удалось создать предмет.';
        }

      } catch (error) {
        console.error('Create Error:', error);
        if (error.response && error.response.status === 401) {
           this.errorMessage = 'Сессия истекла.';
        } else {
           this.errorMessage = 'Ошибка сервера при создании.';
        }
      } finally {
        this.loading = false;
      }
    },

    // 4. DELETE SUBJECT
    async deleteSubject(id) {
      if (!confirm('Вы уверены, что хотите удалить этот предмет?')) return;

      const token = localStorage.getItem('token');

      try {
        // ✅ USE API_URL + Endpoint
        const response = await axios.delete(
          API_URL + `/api/subject/${id}`,
          {
            headers: {
              'accept': '*/*',
              'Authorization': `Bearer ${token}`
            }
          }
        );

        if (response.data && (response.data.code === 200 || response.status === 200)) {
           this.successMessage = 'Предмет успешно удален.';
           this.fetchSubjects(); // Refresh current page
        } else {
           this.errorMessage = 'Не удалось удалить предмет (API вернул ошибку).';
        }

      } catch (error) {
        console.error('Delete Error:', error);
        this.errorMessage = 'Ошибка при удалении предмета.';
      }
    },

    // Helper for date formatting
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleString('ru-RU');
    }
  }
};
</script>

<style scoped>
.mb-3 { margin-bottom: 1rem; }
.btn-block { width: 100%; display: block; }
.close { float: right; font-size: 1.5rem; font-weight: 700; line-height: 1; color: #000; text-shadow: 0 1px 0 #fff; opacity: .5; background: transparent; border: 0; cursor: pointer;}
.pagination-controls { display: flex; align-items: center; }
.mx-3 { margin-left: 1rem; margin-right: 1rem; }
</style>
